export const experimentationToggles = {
  // ...toggles here
} as const
